export const START_NEW_GAME = 'START_NEW_GAME';
export const GAME_OVER = 'GAME_OVER';

export const ADD_SCORE = 'ADD_SCORE';
export const CLEAN_RECENT_ADDED_SCORE = 'CLEAN_RECENT_ADDED_SCORE';
export const UPDATE_BEST_SCORE = 'UPDATE_BEST_SCORE';

export const GENERATE_NEW_TILE = 'GENERATE_NEW_TILE';
export const MERGE_TILE = 'MERGE_TILE';
export const PRE_MERGE_TILE = 'PRE_MERGE_TILE';
export const MOVE_TILE = 'MOVE_TILE';

export const RESET_NEW_MERGED_TILE_TAG = 'RESET_NEW_MERGED_TILE_TAG';
export const RESET_NEW_GENERATED_TILE_TAG = 'RESET_NEW_GENERATED_TILE_TAG';
